export var FormFieldType;
(function (FormFieldType) {
    FormFieldType["Text"] = "text";
    FormFieldType["Amount"] = "amount";
    FormFieldType["Select"] = "select";
    FormFieldType["AutoComplete"] = "autocomplete";
    FormFieldType["Date"] = "date";
    FormFieldType["TextArea"] = "textarea";
    FormFieldType["Radio"] = "radio";
    FormFieldType["CheckBox"] = "checkbox";
    FormFieldType["File"] = "file";
    FormFieldType["ChipSelect"] = "chipSelect";
    FormFieldType["Action"] = "action";
    FormFieldType["AddressAutoComplete"] = "addressAutocomplete";
})(FormFieldType || (FormFieldType = {}));
export var FormLabelPlacement;
(function (FormLabelPlacement) {
    FormLabelPlacement["Floating"] = "floating";
    FormLabelPlacement["Above"] = "above";
})(FormLabelPlacement || (FormLabelPlacement = {}));
export var FormSectionVariant;
(function (FormSectionVariant) {
    FormSectionVariant["Filled"] = "filled";
    FormSectionVariant["Plain"] = "plain";
})(FormSectionVariant || (FormSectionVariant = {}));
export var FormGroupVariant;
(function (FormGroupVariant) {
    FormGroupVariant["Plain"] = "plain";
    FormGroupVariant["Card"] = "card";
    FormGroupVariant["Highlighted"] = "highlighted";
})(FormGroupVariant || (FormGroupVariant = {}));
export var FormActionIcon;
(function (FormActionIcon) {
    FormActionIcon["Search"] = "search";
})(FormActionIcon || (FormActionIcon = {}));
